import { addImageModalActionTypes } from '@/components/modals/addImage/Constants';

import type {
	AddImageModalData,
	ClearAddImageModalStateAction,
	GetImagesErrorAction,
	GetImagesRequestAction,
	GetImagesSuccessAction,
	HandleAddImageModalAction,
	UploadImageErrorAction,
	UploadImageRequestAction,
	UploadImageSuccessAction,
} from './types';

export function handleAddImageModal(data: AddImageModalData): HandleAddImageModalAction {
	return {
		type: addImageModalActionTypes.HANDLE_ADD_IMAGE_MODAL,
		payload: {
			data,
		},
	};
}

export function getImagesRequest(query: string): GetImagesRequestAction {
	return {
		type: addImageModalActionTypes.GET_IMAGES_REQUEST,
		error: true,
		payload: {
			query,
		},
	};
}

export function getImagesSuccess(images: { image_urls: string[] }): GetImagesSuccessAction {
	return {
		type: addImageModalActionTypes.GET_IMAGES_SUCCESS,
		payload: {
			images,
		},
	};
}

export function getImagesError(): GetImagesErrorAction {
	return {
		type: addImageModalActionTypes.GET_IMAGES_ERROR,
	};
}

export function uploadImageRequest(file: File | Blob, itemId: string): UploadImageRequestAction {
	return {
		type: addImageModalActionTypes.UPLOAD_IMAGE_REQUEST,
		payload: {
			file,
			itemId,
		},
	};
}

export function uploadImageSuccess(publicLink: string, itemId: string): UploadImageSuccessAction {
	return {
		type: addImageModalActionTypes.UPLOAD_IMAGE_SUCCESS,
		payload: {
			publicLink,
			itemId,
		},
	};
}

export function uploadImageError(): UploadImageErrorAction {
	return {
		type: addImageModalActionTypes.UPLOAD_IMAGE_ERROR,
	};
}

export function clearAddImageModalState(): ClearAddImageModalStateAction {
	return {
		type: addImageModalActionTypes.CLEAR_ADD_IMAGE_MODAL_STATE,
	};
}
